import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';

@Component({
  selector: 'app-list-paginator',
  standalone: true,
  imports: [MatPaginatorModule],
  template: `
    <mat-paginator #paginator 
      [length]="appStateService.folder.totalItems" 
      [pageSize]="appStateService.folder.itemsPerPage" 
      [pageSizeOptions]="pageSizeOptions"
      (page)="getPaginatorData($event)">
    </mat-paginator>
    
  `,
  styleUrls: [],
})
export class ListPaginatorComponent implements OnInit {

  @Input() listado!: number;
  @Input() pageSizeOptions: number[] = [6];
  @ViewChild('paginator', { static: true }) paginator!: MatPaginator;
  
  itemsPerPageOptions : number[] | undefined;

  constructor(public appStateService: AppStateService) { }

  ngOnInit(): void {
    this.appStateService.ListPaginator = this.paginator;
  }

  getPaginatorData(event: any){
    this.appStateService.folder.itemsPerPage = event.pageSize;
    this.appStateService.folder.page = event.pageIndex + 1;
    
    switch(this.listado){
      
      case 2: 
        this.appStateService.UserService.GetListUsers().subscribe();
        break;
  
        case 3: 
        this.appStateService.CompanyServices.GetListEnterpriseManager().subscribe();
        break;
      default:
        //ilusion de carga para la interaccion con el user!
        this.appStateService.loading = true;
        setTimeout(()=>{
          this.appStateService.loading = false;
        },2000);
        break;
    } 
  }

}
